import '../index_mWeb.css';
import FlatList from 'flatlist-react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import {
  EmptyData,
  ErrorMessage,
  FlatListWrapper,
  PaginationIndicator,
  PlaceHolder,
  TransactionEarningItem,
  View,
  Text
} from '../../../../component';
import I18n from '../../../../utilities/locale';
import useTheme from '../../../../utilities/hooks/theme';
import { convertToDollars } from '../../../../utilities/helper';

const BonusEarningsMWeb = ({
  onPressRetryDeposit,
  resultArrived,
  error,
  totalEarning,
  _onRefresh,
  depositList,
  hasMoreItems,
  loadMoreItems
}: any) => {
  const { AccountTheme: theme } = useTheme();
  const renderItem = (item: any) => <TransactionEarningItem item={item} />;

  const renderWhenEmpty = () => {
    if (error) return <ErrorMessage onPressRetry={onPressRetryDeposit} />;
    if (!resultArrived) return <PlaceHolder.Loader />;
    return <EmptyData message={'No Transaction found'} />;
  };

  const totalEarningColor = {
    color: theme.transactionTotalEarnings
  };
  return (
    <View className={'transaction-history-container__mWeb'}>
      {resultArrived && (
        <View className={'total-earning-container__mWeb'}>
          <Text className={'total-earning-title__mWeb'} style={totalEarningColor}>
            {I18n.t('totalEarnings')}
          </Text>
          <Text
            className={'total-earning-value__mWeb'}
            style={totalEarningColor}>{`  : ${convertToDollars(totalEarning)}/-`}</Text>
        </View>
      )}
      <PullToRefresh onRefresh={_onRefresh}>
        <FlatListWrapper className="flat-list-earning">
          <FlatList
            renderItem={renderItem}
            list={depositList}
            renderWhenEmpty={renderWhenEmpty}
            hasMoreItems={hasMoreItems}
            loadMoreItems={loadMoreItems}
            // renderOnScroll
            paginationLoadingIndicator={<PaginationIndicator />}></FlatList>
        </FlatListWrapper>
      </PullToRefresh>
    </View>
  );
};
export default BonusEarningsMWeb;
